export interface Tool {
  name: string;
  tooltipText: string;
}

export const TOOLS: Record<string, Tool> = {
  addLabel: {
    name: 'addLabel',
    tooltipText: 'Add label',
  },
  hideLabel: {
    name: 'hideLabel',
    tooltipText: 'Hide label',
  },
  highlight: {
    name: 'highlight',
    tooltipText: 'Highlight',
  },
  hideHighlights: {
    name: 'hideHighlights',
    tooltipText: 'Hide highlights',
  },
  addNote: { name: 'addNote', tooltipText: 'Add note' },
  hideNotes: { name: 'hideNotes', tooltipText: 'Hide notes' },
  editText: { name: 'editText', tooltipText: 'Text editor' },
  pen: { name: 'pen', tooltipText: 'Pen' },
  hideDrawings: { name: 'hideDrawings', tooltipText: 'Hide pen' },
  imageEditor: { name: 'imageEditor', tooltipText: 'Edit images' },
  undo: { name: 'undo', tooltipText: 'Undo' },
  redo: { name: 'redo', tooltipText: 'Redo' },
  reset: { name: 'reset', tooltipText: 'Reset' },
  hideText: { name: 'hideText', tooltipText: 'Hide text' },
  save: { name: 'save', tooltipText: 'Save as new text' },
  close: { name: 'close', tooltipText: 'Close' },
};
